import React, { Component, Fragment } from 'react';
import BoxMessage from '../BoxMessage';
import iconMegaphone from './images/megaphone.svg';
import iconAnalysis from './images/analysis.svg';
import iconSupport from './images/support.svg';

import './style/media.scss';
import api from '../../services/api';
import { ContentTitle } from '../utilities/styledComponents/ContentTitle';

import logo from './images/logomidiacolorida.png';
import AlertStatus from '../AlertStatus';
import { TextLoader } from '../utilities/styledComponents/TextLoader';
import mail from '../Briefing/images/mail.svg';
import phone from '../Briefing/images/call-answer.svg';
import whatsapp from '../Briefing/images/whatsapp.svg';
import CampaignMidia from '../../containers/campanhas/MidiaCampanhas/index';
import WithoutMedia from '../../containers/campanhas/WithoutMedia';

const BoxMessageContent = () => (
	<Fragment>
		<img src={logo} alt="Logo gearbox" />
		<h3>VEM PRO GEARBOX!</h3>
		<p>
			Gearbox é o time de especialistas Webmotors que passa os
			dias pensando em soluções para promover e impulsionar sua
			loja na internet! Planejamento, estratégia, criação de sites
			e campanhas digitais: Tudo para sua loja aparecer nas
			redes e atrair compradores potenciais! Você lojista
			ou concessionária que precisa dar um gás
			nas vendas, fale com seu representante Webmotors
			para injetar uma potência à mais em seus negócios.
		</p>
	</Fragment>
);

export default class BriefingsList extends Component {
	state = {
		dataBriefings: [],
		countNewsBriefings: 0,
		withMidia: false,
        errors: false,
		loading: true,
	};

	componentDidMount() {
		this.setState({ loading: true });

		if (localStorage.getItem('errors')) {
			this.setState({
				errors: true,
			});
		}

		this.getProducts();

		api.get('/briefings')
			.then((response) => {
				this.setState({ dataBriefings: response.data.data });
				this.setState({ countNewsBriefings: this.countBriefings() });
			});
	}

	getProducts = () => api.get('/users/me/products')
		.then((response) => {
			const data = response.data;

			if (typeof data.data.attributes.products !== 'undefined'
				&& data.data.attributes.products !== null
			) {
				const products = data.data.attributes.products instanceof Array
					? data.data.attributes.products.join(',')
					: Object.values(data.data.attributes.products).join(',');

				localStorage.setItem('products', products);

				this.setState({
					products,
				}, this.checkMedia);
			}
		})
		.catch((err) => {
			if (process.env.REACT_APP_ENV !== 'production') {
				localStorage.setItem('errors', err.toString());
			}
		})
		.finally(() => {
			this.setState({
				loading: false,
			});
        });


	checkMedia = () => {
		const { products } = this.state;
		if (products && products.toLowerCase().indexOf('media') !== -1) {
			this.setState({
				withMidia: true,
			});
		}
	};

	countBriefings = () => {
		const { dataBriefings } = this.state;
		const totBriefings = dataBriefings.reduce((accumulator, element) => {
			if (element.status === 1 || element.status === 3) {
				return accumulator + 1;
			}
			return accumulator;
		}, 0);
		return totBriefings;
	};

	renderLoader = () => (
		<TextLoader>
			<span>Carregando...</span>
		</TextLoader>
	);

	renderUserHasNoMedia = () => {
		const { loading } = this.state;
		return loading ? this.renderLoader() : <CampaignMidia />;
	}

	renderUserHasMedia = () => {
		const {
			countNewsBriefings, withMidia, errors, dataBriefings,
		} = this.state;
		return (
			<div className="componentMedia">
				<div className="content-welcome p-0">
					<ContentTitle fontSize="32px">Campanhas</ContentTitle>
					<div className="container-fluid spacing-gearbox">
						<div className="row">
							<div className="col-12">
								<article className="containerMidia">
									<section className="contentMidia">
										{errors && (
										<div className="mb-4">
											<AlertStatus
												message="Desculpe! Estamos com uma instabilidade, por favor, tente de novo mais tarde."
												status="error"
											/>
										</div>
										)
									}
										{ (withMidia || dataBriefings.length > 0) && (
										<>
											<BoxMessage>
												<BoxMessageContent />
											</BoxMessage>
											<div className="content-box-line pb-5">
												<div className={`box-new-campaign ${countNewsBriefings ? 'news-briefings-active' : ''}`}>
													<a href="./briefings" className={countNewsBriefings ? 'notification-briefings' : 'd-none'}>{countNewsBriefings}</a>

													<div className="box-top">
														<img src={iconMegaphone} alt="Ícone de relatório" className="icon" />
														<h4>Briefing</h4>
													</div>

													<div className="box-content">
														<img src={iconMegaphone} alt="Ícone de megafone" />
														<h3>MEUS BRIEFINGS</h3>
														<p>
															Aqui você preenche os briefings pendentes e também
															pode consultar o histórico de briefings preenchidos
															em campanhas passadas.
														</p>
													</div>

													<a href="./briefing" className="btn btn-danger">Meus briefings</a>
												</div>

												<div className="container-box-side">
													<div className="box-report eh-box">
														<div className="box-report-title eh-box-title">
															<img src={iconAnalysis} alt="Ícone de relatório" className="icon" />
															<h4>Relatórios da campanha</h4>
														</div>
														<div className="box-report-content eh-box-content m-0 d-flex justify-content-center align-items-center">
															<p className="m-0">
																Quer acompanhar a performance das suas campanhas? <br />
																Confira os relatórios disponíveis!
															</p>
														</div>
														<a href="./relatorios" className="btn btn-danger">Relatórios de campanha</a>
													</div>

													<div className="box-help eh-box">
														<div className="eh-box-title">
															<img src={iconSupport} alt="Ícone de help desk" className="icon" />
															<h4>Helpdesk</h4>
														</div>
														<div className="eh-box-content">
															<p>
																Está com dúvidas ou precisa solucionar algum problema?
																Utilize um dos canais abaixo para falar conosco!
															</p>
															<div className="content-icons">
																<div className="wrapper-icons">
																	<div className="box-icon">
																		<img src={mail} alt="Ícone e-mail." className="icon-mail" />
																		<a
																			href="mailto:gearbox@webmotors.com.br"
																			rel="noopener noreferrer"
																			target="_blank"
																		>
																			gearbox@webmotors.com.br
																		</a>
																	</div>

																	<div className="box-icon">
																		<img src={phone} alt="Ícone telefone." className="icon-phone" />
																		<a href="tel:1126260762" rel="noopener noreferrer" target="_self">
																			(11) 2626-0762
																		</a>
																	</div>

																	<div className="box-icon">
																		<img src={whatsapp} alt="Ícone whatsapp." className="icon-whatsapp" />
																		<a
																			href="https://wa.me/5511989388514"
																			rel="noopener noreferrer"
																			target="_blank"
																		>
																			(11) 9 8938-8514
																		</a>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</>
									)}
									</section>
								</article>
							</div>
						</div>
					</div>
				</div>
			</div>
	);
}

	renderMediaContent = () => {
		const { withMidia } = this.state;
		if (withMidia) {
			return this.renderUserHasMedia();
		}
		return <WithoutMedia />;
	}

	render() {
		const { loading } = this.state;
		return loading ? this.renderLoader() : this.renderMediaContent();
	}
}
